import $ from "jquery";

export function removeFormErrors(form) {
    form.children().filter('.formerror').html("");
}


export function appendFormError(input) {
    var target = input.data('validation');
    var targets = target.split(',');
    var errorMessage = input.attr('data-error-message') || input.get(0).validationMessage;
    for (var i = 0; i < targets.length; i++) {
        target = targets[ i ];
        var formError = $('#' + target);
        if (!formError.children().length) {
            formError.append("<span>" + errorMessage + "</span>");
        }
    }
    input.off('input.formerror change.formerror').on('input.formerror change.formerror', function () {
        var targets = input.data('validation').split(',');
        var isValid = input.get(0).validity.valid;
        var errMsg = input.attr('data-error-message') || input.get(0).validationMessage;
        for (var i = 0; i < targets.length; i++) {
            var formError = $('#' + targets[ i ]);
            if (isValid) {
                formError.html('');
            } else if (!formError.children().length) {
                formError.append('<span>' + errMsg + '</span>');
            }
        }
    });
}


// Updates the form errors for a given form ID
// using HTML 5 Validation
// each input requires a data-validation tag that holds
// the ID of the formerror div
export function updateFormErrors(formID) {
    var form = $('#' + formID);
    removeFormErrors(form);
    var children = form.children().children();
    children.filter('input,select').each(function () {
        if ($(this).get(0).validity.valid == false) {
            appendFormError($(this));
        }
    });
}
